import o from "canvas-confetti";
const i = (a = 3) => {
  const t = Date.now() + a * 1e3, e = () => {
    o({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      zIndex: 2e3
    }), o({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      zIndex: 2e3
    }), Date.now() < t && requestAnimationFrame(e);
  };
  e();
}, s = () => {
  const t = {
    origin: { y: 0.7 }
  };
  function e(n, r) {
    o({
      ...t,
      ...r,
      particleCount: Math.floor(200 * n)
    });
  }
  e(0.25, {
    spread: 26,
    startVelocity: 55
  }), e(0.2, {
    spread: 60
  }), e(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  }), e(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2
  }), e(0.1, {
    spread: 120,
    startVelocity: 45
  });
};
export {
  s as realisticLook,
  i as schoolPride
};
//# sourceMappingURL=index.js.map
